const icon = {
  display: "inline-block",
  lineHeight: "1",
  verticalAlign: "middle"
};
const iconLg = { fontSize: "3rem", "&::before": { fontSize: "3rem" } };
const iconMd = {
  fontSize: "1.75rem",
  "&::before": { fontSize: "1.75rem" }
};
const iconSm = {
  fontSize: "1.375rem",
  "&::before": { fontSize: "1.375rem" }
};
const iconXl = {
  fontSize: "3.875rem",
  "&::before": { fontSize: "3.875rem" }
};

export { icon, iconLg, iconMd, iconSm, iconXl };
